export const paginationPageSize = 'pagination-page-size';
